
import { Component, Vue, Prop } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import draggable from "vuedraggable";
import SearchItem from "./DeviceSearchItem.vue";
import { productList } from "@/api/device";

@Component({
  name: "DeviceSearch",
  components: {
    draggable,
    SearchItem,
  },
})
export default class extends Vue {
   @Prop({
     type: Number,
     default: 1
   })
  deviceType!: any;
 @Prop({
   type: Object,
   default: () => {}
 })
  deviceData!: any;

  private isToggle = false;
  private checkList: any = [];
  private searchArray: any = [];
  private form: any = {
    servicer: '',
    customer: '',
    device: "",
    serial: "",
    sn: "",
    brand: {},
    product: {},
    model: {},
    describe: "",
    address: "",
    area: "",
    auth: "",
    // dept:{id:0,name:''},
    dept:{},
  };
  private searchKey = "";
  private visiblePopover = false;
  private productList = [];
  private moduleList = [];

  created() {
    if (this.deviceData && this.deviceData.customer) {
      this.form.customer = this.deviceData.customer
    }
    this.searchKey = "lsjl_search" + this.$route.path;
    let index = this.searchKey.lastIndexOf("/");
    if (index > 0) {
      this.searchKey = this.searchKey.substr(0, index);
    }
    if (localStorage.getItem(this.searchKey)) {
      let local: any = localStorage.getItem(this.searchKey);
      let localParse = JSON.parse(local);
      for (let p = 0; p < localParse.length; p++) {
        localParse[p].fields = '';
      }
      if (this.deviceType === 3) {
        for (let i = 0; i < localParse.length; i++) {
          if (localParse[i].id === '9') {
            localParse[i].show = true
            localParse[i].isDisabled = false
          }
        }
      } else {
        for (let i = 0; i < localParse.length; i++) {
          if (localParse[i].id === '9') {
            localParse[i].show = false
            localParse[i].isDisabled = true
          }
        }
      }
      if (this.deviceType === 2) {
        for (let i = 0; i < localParse.length; i++) {
          if (localParse[i].id === '10') {
            localParse[i].show = true
            localParse[i].isDisabled = false
          }
        }
      } else {
        for (let i = 0; i < localParse.length; i++) {
          if (localParse[i].id === '10') {
            localParse[i].show = false
            localParse[i].isDisabled = true
          }
        }
      }
      if (this.deviceType === 1) {
        for (let i = 0; i < localParse.length; i++) {
          if (localParse[i].id === '7' || localParse[i].id === '8') {
            localParse[i].show = true
            localParse[i].isDisabled = false
          }
        }
      } else {
        for (let i = 0; i < localParse.length; i++) {
          if (localParse[i].id === '7' || localParse[i].id === '8') {
            localParse[i].show = false
            localParse[i].isDisabled = true
          }
        }
      }
      this.searchArray = localParse;
    } else {
      this.searchArray = [
        {
          fields: this.form.servicer,
          name: "服务方",
          id: "9",
          checked: true,
          isDisabled: false,
          show: this.deviceType === 3,
        },
        {
          fields: this.form.customer,
          name: "客户",
          id: "10",
          checked: true,
          isDisabled: false,
          show: this.deviceType === 2,
        },
        {
          fields: this.form.device,
          name: "设备名称",
          id: "1",
          checked: true,
          show: true,
        },
        {
          fields: this.form.serial,
          name: "设备编号",
          id: "2",
          checked: true,
          show: true,
        },
        {
          fields: this.form.sn,
          name: "设备SN号",
          id: "3",
          checked: true,
          show: true,
        },
        {
          fields: this.form.brand,
          name: "设备品牌",
          id: "4",
          checked: false,
          show: true,
        },
        {
          fields: this.form.product,
          name: "设备类型",
          id: "5",
          list: [],
          checked: false,
          show: true,
        },
        {
          fields: this.form.model,
          name: "设备型号",
          id: "6",
          list: [],
          checked: false,
          show: true,
        },
        {
          fields: this.form.describe,
          name: "设备描述",
          id: "12",
          checked: false,
          isDisabled: false,
          show: this.deviceType === 1,
        },
        {
          fields: this.form.address,
          name: "设备地址",
          id: "7",
          checked: false,
          isDisabled: false,
          show: this.deviceType === 1,
        },
        {
          fields: this.form.area,
          name: "设备区域",
          id: "13",
          checked: false,
          isDisabled: false,
          show: this.deviceType === 1,
        },
        {
          fields: this.form.auth,
          name: "授权状态",
          id: "8",
          checked: false,
          isDisabled: false,
          show: this.deviceType === 1,
        },
        {
          fields: this.form.dept,
          name: "设备部门",
          id: "11",
          checked: false,
          isDisabled: false,
          show: this.deviceType === 1,
        },
      ];
    }
  }

  private handleSearch() {
    const params = {
      servicer: this.form.servicer.id ? this.form.servicer.id : '',
      customer: this.form.customer.id ? this.form.customer.id : '',
      number: this.form.serial,
      device_name: this.form.device,
      sn: this.form.sn,
      brand_id: this.form.brand.id ? this.form.brand.id : "",
      product_id: this.form.product.id ? this.form.product.id : "",
      model_id: this.form.model.id ? this.form.model.id : "",
      describe: this.form.describe,
      address: this.form.address,
      device_area: this.form.area,
      is_auth: this.form.auth,
      dept_id: this.form.dept.id ? this.form.dept.id : "",
    };
    console.log(params);
    this.$emit("deviceSearch", params);
  }

  private handleClear() {
    this.form = {
      servicer: '',
      customer: '',
      device: "",
      serial: "",
      sn: "",
      brand: {},
      product: {},
      model: {},
      describe: "",
      address: "",
      area: "",
      auth: "",
      dept:{},
    };
    if (this.form.brand) {
      this.form.brand.id = "";
      this.form.brand.name = "";
    }
    if (this.form.product) {
      this.form.product.id = "";
      this.form.product.name = "";
    }
    if (this.form.model) {
      this.form.model.id = "";
      this.form.model.name = "";
    }
    if (this.form.dept) {
      this.form.dept.id = "";
      this.form.dept.name = "";
    }
    if (this.searchArray) {
      for (let v = 0; v < this.searchArray.length; v++) {
        this.searchArray[v].fields = "";
      }
    }
    this.handleSearch();
  }

  private formReceive(val: any, keyup: any) {
    let parameters: any = {};
    parameters.company_id = UserModule.getCompanyId;
    switch (val.id) {
      case "1":
        this.form.device = val.fields;
        break;
      case "2":
        this.form.serial = val.fields;
        break;
      case "3":
        this.form.sn = val.fields;
        break;
      case "4":
        this.form.brand = val.fields;
        if (this.form.brand.id) {
          parameters.product_type = 2;
          parameters.brand_id = this.form.brand.id;
          productList(parameters)
            .then((res) => {
              if (res.data) {
                this.productList = res.data.list;
                for (let t = 0; t < this.searchArray.length; t++) {
                  if (this.searchArray[t].id === '5') {
                    this.$set(this.searchArray[t], 'list', this.productList)
                  }
                }
              } else {
                this.productList = [];
              }
            })
            .catch((error) => {
              let msg = error.msg;
            });
        }
        break;
      case "5":
        this.form.product = val.fields;
        if (this.form.product.id) {
          parameters.product_type = 3;
          parameters.brand_id = this.form.brand.id;
          parameters.product_id = this.form.product.id;
          productList(parameters)
            .then((res) => {
              if (res.data) {
                this.moduleList = res.data.list;
                for (let t = 0; t < this.searchArray.length; t++) {
                  if (this.searchArray[t].id === '6') {
                    this.$set(this.searchArray[t], 'list', this.moduleList)
                  }
                }
              } else {
                this.moduleList = [];
              }
            })
            .catch((error) => {
              let msg = error.msg;
            });
        }
        break;
      case "6":
        this.form.model = val.fields;
        break;
      case "7":
        this.form.address = val.fields;
        break;
      case "8":
        this.form.auth = val.fields;
        break;
      case "9":
        this.form.servicer = val.fields;
        break;
      case "10":
        this.form.customer = val.fields;
        break;
      case "11":
        //部门进行处理
        this.form.dept = val.fields;
        break;
      case "12":
        this.form.describe = val.fields;
        break;
      case "13":
        this.form.area = val.fields;
        break;
    }
    if (keyup) {
      this.handleSearch();
    }
  }

  toggleHandle() {
    this.isToggle = !this.isToggle;
  }
  confirmHandle() {
    let setItem: any = [];
    setItem = this.searchArray.filter(
      (t: any) => !this.checkList.some((ele: any) => ele.id === t.id)
    );
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < setItem.length; i++) {
        if (this.searchArray[m].id === setItem[i].id) {
          this.searchArray[m].checked = false; // 设置取消
        }
      }
    }
    for (let m = 0; m < this.searchArray.length; m++) {
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.searchArray[m].id === this.checkList[i].id) {
          this.searchArray[m].checked = true; // 设置选中
        }
      }
    }
    this.settingLocal();
    this.visiblePopover = false;
  }

  settingLocal() {
    localStorage.setItem(this.searchKey, JSON.stringify(this.searchArray));
  }
}
